import { AfterViewInit, Component, inject, ViewChild } from '@angular/core';
import { getIdToken } from '@angular/fire/auth';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { BaseComponent } from '../../shared/base.component';
import { AddDealerState } from '../../shared/state-interface';
import { CountriesComponent } from '../../ui-components/countries/countries.component';
import { SiteHeaderComponent } from '../../site-header/site-header.component';
import { DealerComponent } from '../shared/dealer.component';
import { Dealer } from '../shared/dealer.model';
import { DealerService } from '../shared/dealer.service';

@Component({
    selector: 'app-add-dealer',
    standalone: true,
    imports: [
        ReactiveFormsModule,
        MatInputModule,
        MatButtonModule,
        SiteHeaderComponent,
        DealerComponent
    ],
    templateUrl: './add-dealer.component.html',
    styleUrl: './add-dealer.component.css'
})
export class AddDealerComponent extends BaseComponent implements AfterViewInit {

    @ViewChild(DealerComponent) dealerComponent!:DealerComponent;

    private dealerService: DealerService = inject(DealerService);

    private static _addingDealer = "Adding Dealer";
    private static _addingDealerError = `${AddDealerComponent._addingDealer} error:`;

    public ngAfterViewInit() {
        const state: AddDealerState | undefined = this.stateManager.addDealerState;

        if (state !== undefined) {
            this.dealerComponent.restoreState(state.dealerComponentState);
            super.restoreState(state.baseComponentState);
        } else {
            this.dealerComponent.init(CountriesComponent.defaultCountry);
        }
    }

    public ngOnDestroy() {
        const state: AddDealerState = {} as AddDealerState;
        state.dealerComponentState = this.dealerComponent.getState();
        state.baseComponentState = super.getState();
        this.stateManager.addDealerState = state;
    }

    protected cancel() {
        this.router.navigate(["/view-dealers"], { state: { restore: true } });
    }

    protected async save() {
        const currentUser = this.auth.currentUser;

        if (currentUser) {
            const dealer: Dealer = this.dealerComponent.createModelFromForm(new Dealer());

            const observable = await this.dealerService.addDealer(await getIdToken(currentUser), dealer);
            this.message = "";
            super.showSnackBar(`${AddDealerComponent._addingDealer}...`, -1);

            observable.subscribe(response => {
                try {
                    const json = JSON.parse(JSON.stringify(response));
                    if (json["add-dealer"] == "success") {
                        this.stateManager.clearDealerNames();
                        const queryParam = `Dealer '${dealer.name}' added.`;
                        this.router.navigate(["/view-dealers"], { queryParams: {"overrideSnackBar": queryParam}, state: { refresh: true } });
                    } else {
                        throw new Error(json["message"]);
                    }
                } catch (error) {
                    const message = `${AddDealerComponent._addingDealerError} ${(<Error>error).message}`;
                    this.message = message;
                    super.dismissSnackBar();
                }
            })
        } else {
            const message = `${AddDealerComponent._addingDealerError} Null user instance`;
            console.error(message)
            super.showSnackBar(message, 30);
        }
    }
}
